import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { ForYou } from './components/sections/ForYou';
import { Manuals } from './components/sections/Manuals';
import { Access } from './components/sections/Access';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ink-900 font-sans text-bone" data-id="element-0" data-mp="23ujlygszdv5m">
      <MetaPixel data-id="element-1" data-mp="3ikh5c1uvgeva" />
      <Hero data-id="element-2" data-mp="3iiwaeb4natww" />
      <main data-id="element-3" data-mp="3ijfw82xf22g7">
        <BeforeAfter data-id="element-4" data-mp="3ijpet5g4t7bv" />
        <ForYou data-id="element-5" data-mp="3mljat0fdtn5p" />
        <Manuals data-id="element-6" data-mp="3ml14faz09sk2" />
        <Access data-id="element-7" data-mp="3mkhlbqxmcy4g" />
        <Bonuses data-id="element-8" data-mp="3mjzsz5e2v41t" />
        <Offer data-id="element-9" data-mp="3mjg9vlcoy9m7" />
        <Testimonials data-id="element-10" data-mp="3mj6lg27aoaim" />
        <Guarantee data-id="element-11" data-mp="3rbrakqf99zft" />
        <About data-id="element-12" data-mp="3rdaselgk8ijp" />
        <Faq data-id="element-13" data-mp="3rcsyvwla8ifh" />
        <FinalCta data-id="element-14" data-mp="3rd17vdeab3le" />
      </main>
      <Footer data-id="element-15" data-mp="5otf64sd496" />
      <FloatingCta data-id="element-16" data-mp="6htjo98ovic" />
      <PurchasePopup data-id="element-17" data-mp="4n4pyuukj8z" />
    </div>;
}